import Vue from 'vue'
import Router from 'vue-router'
// ============ Error Pages =========
import Err404 from '@/components/errorPages/err404'
import Err500 from '@/components/errorPages/err500'
import Err401 from '@/components/errorPages/err401'
// ============ Error Pages =========
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    // **********************************
    // ---------- Error Pages -----------
    // **********************************
    { path: '/err404', name: 'Err404', component: Err404 },
    { path: '/err500', name: 'Err500', component: Err500 },
    { path: '/err401', name: 'Err401', component: Err401 },
    // **********************************
    // ---------- Login Page -----------
    // **********************************
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/components/Login')
    },

    { path: '/',
      name: 'Home',
      component: () => import('@/components/Home'),
      beforeEnter: (to, from, next) => {
        if (sessionStorage.getItem('isLogin')) {
          next()
        } else {
          next('/login')
        }
      },
      children: [
        {
          path: '/dashborad',
          name: 'DashBoard',
          component: () => import('@/components/DashBoard')
        },
        // **********************************
        // ---------- Main Page -----------
        // **********************************
        {
          path: '/job-title',
          name: 'JobTitle',
          component: () => import('@/components/pages/MainData/JobTitle')
        },
        {
          path: '/branch',
          name: 'Branch',
          component: () => import('@/components/pages/MainData/Branch')
        },
        {
          path: '/bonus-level-type',
          name: 'BonusLevelType',
          component: () => import('@/components/pages/MainData/BonusLevelType')
        },
        {
          path: '/ray',
          name: 'Ray',
          component: () => import('@/components/pages/MainData/Ray')
        },
        {
          path: '/expense-group',
          name: 'ExpenseGroup',
          component: () => import('@/components/pages/MainData/ExpenseGroup')
        },
        {
          path: '/expense-type',
          name: 'ExpenseType',
          component: () => import('@/components/pages/MainData/ExpenseType')
        },
        // **********************************
        // *********Branchray Pages************
        // **********************************
        {
          path: '/branch-ray',
          name: 'BranchRay',
          component: () => import('@/components/pages/BranchData/BranchRay')
        },
        {
          path: '/doctor',
          name: 'Doctor',
          component: () => import('@/components/pages/BranchData/Doctor')
        },
        {
          path: '/patient',
          name: 'Patient',
          component: () => import('@/components/pages/BranchData/Patient')
        },
        {
          path: '/bonus-price',
          name: 'BonusPrice',
          component: () => import('@/components/pages/BranchData/BonusPrice')
        },
        {
          path: '/expense',
          name: 'Expense',
          component: () => import('@/components/pages/BranchData/Expense')
        },
        {
          path: '/withdrawal',
          name: 'Withdrawal',
          component: () => import('@/components/pages/BranchData/Withdrawal')
        },
        {
          path: '/outcome',
          name: 'Outcome',
          component: () => import('@/components/pages/BranchData/Outcome')
        },
        {
          path: '/incentive',
          name: 'Incentive',
          component: () => import('@/components/pages/BranchData/Incentive')
        },
        {
          path: '/diary',
          name: 'Diary',
          component: () => import('@/components/pages/BranchData/Diary')
        },
        {
          path: '/treasury-movement',
          name: 'TreasuryMovement',
          component: () => import('@/components/pages/BranchData/TreasuryMovement')
        },
        {
          path: '/diary-procedures',
          name: 'DiaryProcedures',
          component: () => import('@/components/pages/BranchData/DiaryProcedures')
        },
        {
          path: '/close-shift',
          name: 'CloseShift',
          component: () => import('@/components/pages/BranchData/CloseShift')
        },
        {
          path: '/shift-report',
          name: 'ShiftReport',
          component: () => import('@/components/pages/BranchData/ShiftReport')
        },
        {
          path: '/doctors-report',
          name: 'DoctorsReport',
          component: () => import('@/components/pages/BranchData/DoctorsReport')
        },
        // ********************************** /doctors-report
        // ************User Pages************
        // **********************************
        {
          path: '/employees',
          name: 'Emp',
          component: () => import('@/components/pages/Employees/Emp')
        },
        {
          path: '/changepassword',
          name: 'ChangePassword',
          component: () => import('@/components/pages/Employees/ChangePassword')
        },
        {
          path: '/changeprofile',
          name: 'ChangeProfile',
          component: () => import('@/components/pages/Employees/ChangeProfile')
        }
      ]
    }
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js